import TopicPortalDisplay from './TopicPortalDisplay';

export default TopicPortalDisplay;
